import React from 'react';

const HoldingMoney: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M95.993 87c2.413 0 5.007 1.92 5.007 4.952 0 2.71-2.247 5.048-5.007 5.048H74m1-20h23.036c2.31 0 4.817 1.796 4.964 4.712v.296C103 84.76 100.772 87 98.036 87h-21.25M45 66H31v39h14V66z"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17 66h14v44H17m72.477-13C91.651 97 94 98.716 94 101.423c0 2.366-.959 4.577-4.507 4.577H60.646c-4.762 0-8.454-1.237-11.267-3.216H45M93.206 77C95.84 77 98 74.762 98 72.077c0-2.989-2.492-4.987-4.794-4.987H67.361c-.71 0-1.246-.176-1.42-.495-.173-.32-.047-.927.363-1.615.426-.719.379-1.726-.047-2.557-.71-1.375-2.476-1.55-3.406-1.358-6.75 1.358-11.922 4.091-15.454 8.167H45"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M68.76 67L65 38.736 71 38m8-4c0 4.964-3.572 9-8 9m31-9c0 4.964 4.019 9 9 9m-9 60c0-4.964 4.019-9 9-9"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M91 18v5m-15-2l2 5m28-5l-2 5"
    ></path>
    <path stroke="#fff" strokeLinejoin="round" strokeWidth="2" d="M71 67.31V34h40v69H93.77"></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M79 67.118C79.622 61.43 84.74 57 90.961 57 97.603 57 103 62.059 103 68.296c0 3.504-1.695 6.63-4.355 8.704"
    ></path>
  </svg>
);

export default HoldingMoney;
